export const OSM_DOMAIN = "https://osm.org";
